import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AddQuestionForm from '../BasicComponents/AddQuestionForm';
import API_BASE_URL from '../Config/config';

const QuestionsList = () => {
 const [questions, setQuestions] = useState([]);
 const [editingId, setEditingId] = useState(null);
 const [editForm, setEditForm] = useState({});

 const fetchQuestions = () => {
 axios.get(`${API_BASE_URL}/api/questions`)
 .then(res => setQuestions(res.data))
 .catch(err => console.error("Error fetching questions:", err));
 };

 useEffect(() => {
 fetchQuestions();
 }, []);

 const handleAdd = (newQ) => {
 setQuestions(prev => [newQ, ...prev]);
 };

 const handleDelete = async (id) => {
 const confirm = window.confirm("Are you sure you want to delete this question?");
 if (!confirm) return;

 try {
 await axios.delete(`${API_BASE_URL}/api/questions/${id}`);
 setQuestions(prev => prev.filter(q => q.id !== id));
 } catch (err) {
 console.error("Failed to delete question:", err);
 }
 };

 const handleEditClick = (question) => {
 setEditingId(question.id);
 setEditForm({ ...question });
 };

 const handleEditChange = (e) => {
 setEditForm({ ...editForm, [e.target.name]: e.target.value });
 };

 const handleEditSubmit = async (e) => {
 e.preventDefault();
 try {
 await axios.put(`${API_BASE_URL}/api/questions/${editingId}`, editForm);
 setQuestions(prev => prev.map(q => (q.id === editingId ? { ...editForm, id: editingId } : q)));
 setEditingId(null);
 setEditForm({});
 } catch (err) {
 console.error("Update failed:", err);
 }
 };

 return (
 <div className="bg-bgMain text-body min-h-screen p-8 relative overflow-hidden font-sans">
 {/* Background decoration */}
 <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -mr-48 -mt-48"></div>
 
 <h2 className="text-4xl font-extrabold mb-10 bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent uppercase tracking-tighter relative z-10">All Coding Questions</h2>
 
 <div className="relative z-10">
 <AddQuestionForm onAdd={handleAdd} />
 </div>

 <div className="space-y-6 relative z-10 mt-12">
 {questions.map((q, index) => (
 <div key={q.id} className="bg-bgSection rounded-[24px] shadow-2xl p-8 mb-4 border border-accentGray/30 relative group transition-all duration-300 hover:border-primary/30">
 {editingId === q.id ? (
 <form onSubmit={handleEditSubmit} className="space-y-4">
 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
 <input name="technology" value={editForm.technology} onChange={handleEditChange} className="p-4 w-full bg-bgMain border border-accentGray/50 text-white rounded-2xl focus:border-primary outline-none transition-all" placeholder="Technology" />
 <input name="question" value={editForm.question} onChange={handleEditChange} className="p-4 w-full bg-bgMain border border-accentGray/50 text-white rounded-2xl focus:border-primary outline-none transition-all" placeholder="Question Text" />
 <input name="option_a" value={editForm.option_a} onChange={handleEditChange} className="p-4 w-full bg-bgMain border border-accentGray/50 text-white rounded-2xl focus:border-primary outline-none transition-all" placeholder="Option A" />
 <input name="option_b" value={editForm.option_b} onChange={handleEditChange} className="p-4 w-full bg-bgMain border border-accentGray/50 text-white rounded-2xl focus:border-primary outline-none transition-all" placeholder="Option B" />
 <input name="option_c" value={editForm.option_c} onChange={handleEditChange} className="p-4 w-full bg-bgMain border border-accentGray/50 text-white rounded-2xl focus:border-primary outline-none transition-all" placeholder="Option C" />
 <input name="option_d" value={editForm.option_d} onChange={handleEditChange} className="p-4 w-full bg-bgMain border border-accentGray/50 text-white rounded-2xl focus:border-primary outline-none transition-all" placeholder="Option D" />
 <select name="correct_option" value={editForm.correct_option} onChange={handleEditChange} className="p-4 w-full bg-bgMain border border-accentGray/50 text-white rounded-2xl focus:border-primary outline-none transition-all">
 <option value="A">Correct Option: A</option>
 <option value="B">Correct Option: B</option>
 <option value="C">Correct Option: C</option>
 <option value="D">Correct Option: D</option>
 </select>
 </div>
 <div className="flex space-x-3 pt-4">
 <button type="submit" className="btn-primary-gradient px-8 py-3 rounded-xl font-bold shadow-lg hover:scale-105 transition-all">Save Changes</button>
 <button onClick={() => setEditingId(null)} className="bg-bgMain text-muted px-8 py-3 rounded-xl font-bold border border-accentGray/50 hover:bg-white/5 transition-all">Cancel</button>
 </div>
 </form>
 ) : (
 <>
 <div className="flex justify-between items-start mb-6">
 <h3 className="text-xl font-bold text-body group-hover:text-primary transition-colors">{index + 1}. {q.question}</h3>
 <div className="flex space-x-2 shrink-0">
 <button
 onClick={() => handleEditClick(q)}
 className="bg-primary/10 text-primary border border-primary/20 hover:bg-primary hover:text-white font-bold py-2 px-4 rounded-xl transition-all text-sm"
 >
 Edit
 </button>
 <button
 onClick={() => handleDelete(q.id)}
 className="bg-red-500/10 text-red-400 border border-red-500/20 hover:bg-red-500 hover:text-white font-bold py-2 px-4 rounded-xl transition-all text-sm"
 >
 Delete
 </button>
 </div>
 </div>
 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
 {['A', 'B', 'C', 'D'].map((opt) => (
 <div key={opt} className={`p-4 rounded-2xl border transition-all ${q.correct_option === opt ? 'bg-primary/10 border-primary/50 text-primary' : 'bg-bgSoft border-accentGray/30 text-muted'}`}>
 <span className="font-bold mr-2">{opt}.</span> {q[`option_${opt.toLowerCase()}`]}
 </div>
 ))}
 </div>
 <div className="mt-6 flex items-center gap-2">
 <span className="text-[10px] font-extrabold text-muted uppercase tracking-widest px-3 py-1 bg-bgMain rounded-full border border-accentGray/30">
 Tech: {q.technology}
 </span>
 </div>
 </>
 )}
 </div>
 ))}
 </div>
 </div>
 );
};

export default QuestionsList;



